/*
 * サブシステム名：
 * 機能名：かんたん日報入力
 * 表示項目カスタマイズ(滋賀自工)
 */

import D2PRMD0040 from '@/views/PRM/D2PRMD0040.js'
import fraction from '@/ddv2.library/fraction'

export default ({
  extends: D2PRMD0040,
  name: 'NippoEasyEditCustomForSGJ',
  data: () => ({
    customJuchuRirekiHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: '受注営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiNm' },
      { text: '商品備考', value: 'hinmeiBiko' },
      { text: '単価', value: 'tankaDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '作業単価', value: 'warimashiKyoriTankaDisp', align: 'end' },
      { text: '作業数量', value: 'warimashiTaishoKyori', align: 'end' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
      { text: '高速代・交通費', value: 'hiwayPriceDisp', align: 'end' },
      { text: 'その他運賃', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: '燃料サーチャージ', value: 'nenryoSurchargeDisp', align: 'end' },
      { text: '積込料', value: 'tsumikomiKingakuDisp', align: 'end' },
      { text: '取卸料', value: 'torioroshiKingakuDisp', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTankaDisp', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
      { text: 'その他付帯業務料', value: 'futaiGyomuKingakuDisp', align: 'end' },
      { text: '非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '不課税', value: 'tatekaekinHikazeiDisp', align: 'end' },
      { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
      { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '傭車高速代', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '受注No', value: 'juchuNo' }
    ],
    customTeikeiCorseHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiNm' },
      { text: '商品備考', value: 'hinmeiBiko' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '作業単価', value: 'warimashiKyoriTanka', align: 'end' },
      { text: '作業数量', value: 'warimashiTaishoKyori', align: 'end' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速代・交通費', value: 'hiwayPrice', align: 'end' },
      { text: 'その他運賃', value: 'unchinHokaKingaku', align: 'end' },
      { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
      { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
      { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
      { text: '非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '不課税', value: 'tatekaekinHikazei', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
      { text: '支払高速代', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
      { text: '支払用備考', value: 'shiharaiBiko' }
    ]
  }),
  computed: {
  },
  methods: {
    inputOdoMater: function () {
      if (this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        let hatsuchiOdoMater = this.viewsData.vwUnkoJisseki.hatsuchiOdoMater
        let chakuchiOdoMater = this.viewsData.vwUnkoJisseki.chakuchiOdoMater

        if (hatsuchiOdoMater === undefined || hatsuchiOdoMater === '' || hatsuchiOdoMater === null) { hatsuchiOdoMater = 0 }
        if (chakuchiOdoMater === undefined || chakuchiOdoMater === '' || chakuchiOdoMater === null) { chakuchiOdoMater = 0 }

        const calcSokoKyori = Math.floor(fraction.calcSubtract(parseFloat(chakuchiOdoMater), parseFloat(hatsuchiOdoMater)) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'sokoKyori', calcSokoKyori)
        this.inputJissekiKyori()
      }
    },
    inputJissekiKyori: function () {
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori
      let kushaKyori = this.viewsData.vwUnkoJisseki.kushaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }
      if (kushaKyori === undefined || kushaKyori === '' || kushaKyori === null) { kushaKyori = 0 }

      let calcKyori = 0

      calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, kushaKyori) * 10) / 10
      this.$set(this.viewsData.vwUnkoJisseki, 'jisshaKyori', calcKyori)
      this.$set(this.viewsData.vwUnkoJisseki, 'kushaKyori', kushaKyori)
    }
  }
})
